var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-video-wrapper",
      attrs: { "data-grm-comp": "RoomVideo" },
    },
    [
      _vm.canvas
        ? _c("div", { ref: "canvasLayer", staticClass: "room-video" })
        : _vm._e(),
      !_vm.canvas
        ? _c("video", {
            ref: "video",
            staticClass: "room-video",
            attrs: { "webkit-playsinline": "", playsinline: "", autoplay: "" },
            domProps: { muted: _vm.muted },
            on: {
              resize: _vm.onEvent,
              play: _vm.onEvent,
              playing: _vm.onEvent,
              pause: _vm.onEvent,
              loadedmetadata: _vm.onEvent,
              loadeddata: _vm.onEvent,
              stalled: _vm.onEvent,
              emptied: _vm.onEvent,
              error: _vm.onEvent,
              progress: _vm.onEvent,
            },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "user-sticker-layer" },
        _vm._l(_vm.videoStickerList, function (sticker) {
          return _c("img", {
            key: sticker.userId + sticker.imagePath,
            style: { ...sticker.setting.style, position: "absolute" },
            attrs: {
              src: `${_vm.cdnUrl}/${_vm.container}/${sticker.imagePath}`,
            },
          })
        }),
        0
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.canvas && _vm.loading,
              expression: "!canvas && loading",
            },
          ],
          staticClass: "user-profile-image-container",
        },
        [
          _c("UserProfileImage", {
            staticClass: "user-profile-image",
            class: {
              "blank-profile-image": _vm.isBlankProfileImage,
            },
            attrs: { "user-id": _vm.user.userId, useBlankImage: true },
            on: {
              emitImageNotFoundEvent: function ($event) {
                _vm.isBlankProfileImage = true
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }